import { Box, Grid, Typography } from "@mui/material";
import { BlFormInput } from "Forms/Components/BlFormInput";
import { StyledLabelAdornment } from "Forms/Components/FormStyles";
import { CurrencyCode } from "Infrastructure/Models/CurrencyCodes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { formatCurrency } from "Infrastructure/Utils/CurrencyUtils";
import { useFormContext } from "react-hook-form";

export const ModifyDepositFields = () => {
  const { t } = useResource();
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext();

  const regularAmount = watch("regularAmount");
  const currentAmount = watch("currentValue");
  const newRegularDeposit = watch("newRegularDeposit");
  const newDeposit = watch("newDeposit");

  return (
    <>
      <Grid size={6}>
        <BlFormInput
          control={control}
          name="newDeposit"
          label={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.NewDeposit)}
          errors={errors}
          unmask="typed"
          mask={[
            {
              mask: Number,
              thousandsSeparator: " ",
              scale: 2,
            },
          ]}
          labelEndAdornment={<StyledLabelAdornment />}
          inputEndAdornment={
            <Typography variant="body2" color="secondary">
              {t(Resources.Common.CZKSuffix)}
            </Typography>
          }
        />

        {currentAmount && newDeposit && newDeposit - currentAmount !== 0 ? (
          <Box sx={{ width: "100%", textAlign: "right", mt: 1 }}>
            <Typography variant="caption" color="secondary">
              {t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.NewDepositDifference)}:{" "}
              {formatCurrency(newDeposit - currentAmount, CurrencyCode.CZK, 2)}
            </Typography>
          </Box>
        ) : null}
      </Grid>

      <Grid size={6}>
        <BlFormInput
          control={control}
          name="newRegularDeposit"
          label={t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.NewRegularDeposit)}
          errors={errors}
          unmask="typed"
          mask={[
            {
              mask: Number,
              thousandsSeparator: " ",
              scale: 2,
              min: 0,
            },
          ]}
          labelEndAdornment={<StyledLabelAdornment />}
          inputEndAdornment={
            <Box sx={{ width: 100 }}>
              <Typography variant="body2" color="secondary">
                {t(Resources.Common.CZKSuffix)}/{t(Resources.Common.Month)}
              </Typography>
            </Box>
          }
        />

        {regularAmount && newRegularDeposit && newRegularDeposit - regularAmount !== 0 ? (
          <Box sx={{ width: "100%", textAlign: "right", mt: 1 }}>
            <Typography variant="caption" color="secondary">
              {t(Resources.AnalysisDetail.GoalsFulfillment.FormFields.NewRegularDepositDifference)}:{" "}
              {formatCurrency(newRegularDeposit - regularAmount, CurrencyCode.CZK, 2)}
            </Typography>
          </Box>
        ) : null}
      </Grid>
    </>
  );
};
